var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"limit_wrap"},[_c('CustomSelect',{attrs:{"name":"pageLimit","options":[10, 25, 50, 100, 200, 500, 1000],"clear":false},model:{value:(_vm.pageLimit),callback:function ($$v) {_vm.pageLimit=$$v},expression:"pageLimit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }